import styled from 'styled-components';

export const StyledPrivacyPolicyPage = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
`;
